import { useMutation } from 'react-query';
import { openApiHandler } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

interface VerifyEmailAnswerProps {
  newPhoneNumber: string;
  stateToken: string;
  customerId: string;
}
export interface ChangePhoneReturn {
  newPhoneNumber: string;
}
export const useChangePhoneMutation = (
  onSuccess: (response: ChangePhoneReturn) => void,
  onError: (error: any) => void,
) =>
  useMutation(
    'changePhoneMutation',
    async ({ newPhoneNumber, stateToken, customerId }: VerifyEmailAnswerProps) => {
      const regex = /[ ()-]/g;
      const cleanPhone = newPhoneNumber.replace(regex, '');

      // eslint-disable-next-line no-useless-catch
      try {
        const data = await openApiHandler(
          `${BASE_URL}/api/v2/user/openauth/${customerId}/phone/change/finish`,
          'POST',
          {
            newPhoneNumber: cleanPhone,
            stateToken },
        );
        return data as ChangePhoneReturn;
      } catch (e) {
        throw e;
      }
    },
    {
      onSuccess: (data) => onSuccess(data),
      onError: (error: IServerErrorResponse) => {
        onError(flattenServerErrorResponse(error));
      },
    },
  );
